// Assign modal Print button — pass the current itemId to export just this item's units,

import apiClient from "../../../apiClient";
import useUnit from "../../../customHooks/useUnit";

export default function useExportData() {

    const unit = useUnit();
    
    // or omit params to export everything the user can see.
    async function exportData(params?: { itemId?: number; status?: string; }) {
        // @ts-ignore
        params.unit = unit;
        
        const res = await apiClient.get('/inventory/export', { params, responseType: 'blob' });
        const url = URL.createObjectURL(res.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'inventory.csv';
        a.click();
        URL.revokeObjectURL(url);
    }

    return {
        exportData
    }

}